import {
  CHAT_V8_RUN_MODES,
  z_ChatV8RunMode,
  type T_ChatV8RunMode,
} from "@lattice/core-lib/types/chat-v8";

const PRISM_RUN_MODE_STORAGE_KEY = "@lattice/prism_run_mode";

export const DEFAULT_CHAT_V8_RUN_MODE: T_ChatV8RunMode = CHAT_V8_RUN_MODES[0];

export function parseStoredChatV8RunMode(
  value: string | null,
): T_ChatV8RunMode {
  const parsed = z_ChatV8RunMode.safeParse(value);
  return parsed.success ? parsed.data : DEFAULT_CHAT_V8_RUN_MODE;
}

export function readStoredChatV8RunMode(): T_ChatV8RunMode {
  if (typeof window === "undefined") return DEFAULT_CHAT_V8_RUN_MODE;
  try {
    return parseStoredChatV8RunMode(
      window.localStorage.getItem(PRISM_RUN_MODE_STORAGE_KEY),
    );
  } catch {
    return DEFAULT_CHAT_V8_RUN_MODE;
  }
}

export function persistChatV8RunMode(mode: T_ChatV8RunMode): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(PRISM_RUN_MODE_STORAGE_KEY, mode);
  } catch {
    // Keep the in-memory selection when storage is unavailable.
  }
}
